import React, {FC, memo} from "react";
import moment, {Moment} from "moment";
import {TimePicker} from "antd";
import {TimePickerProps} from "antd/lib/time-picker";
import useTypedPicker from "../../views/DateInput/useTypedPicker";

// Beim Tippen akzeptierte Formate; das erste ist das Anzeigeformat
export const TIME_INPUT_FORMATS = ["HH:mm", "H:mm", "HH.mm", "H.mm", "HHmm", "Hmm", "HH", "H"];

const parse = (text: string) => {
    const typed = moment(text, TIME_INPUT_FORMATS, true);

    return typed.isValid() ? typed : null;
};

// Nur Stunde und Minute zählen: das Datum des Werts ist bei Uhrzeitfeldern beliebig
const isSameTime = (a: Moment, b: Moment) => a.format("HH:mm") === b.format("HH:mm");

export type CustomTimeInputProps = Omit<TimePickerProps, "format">;

// TimePicker, der Getipptes und eine Auswahl im Panel genau einmal meldet: bei
// Enter, Tab, Klick daneben oder „OK“, und nur, wenn sich die Uhrzeit ändert.
// Escape verwirft. Ohne allowClear lässt sich das Feld nicht leeren.
const CustomTimeInput: FC<CustomTimeInputProps> = (props) => {
    const {allowClear = false, value, defaultValue, open, onChange, onFocus, onOpenChange, onSelect, ...restProps} = props;
    const {wrapperProps, pickerProps} = useTypedPicker({...props, allowClear}, {parse, isSame: isSameTime, format: TIME_INPUT_FORMATS[0]});

    return (
        <span {...wrapperProps}>
            <TimePicker format={TIME_INPUT_FORMATS} allowClear={allowClear} {...restProps} {...pickerProps} />
        </span>
    );
};

export default memo(CustomTimeInput);
